import {
    SET_ASSET_FLEET_HEADER_DETAILS,
    SET_ASSET_OREDR_HEADER_DETAILS,
    SET_ASSET_FLEET_ITEM_DETAILS,
    SET_ASSET_FLEET_TASK_DETAILS,
    SET_ASSET_ASSIGNED_TO_FOR_ALL_ITEM,
    SET_ASSET_OPEN_ACCORDION_LIST,
    SET_AFE_FLEET_HEADER_DETAILS,
    SET_AFE_FLEET_ITEM_DETAILS,
    SET_AFE_FLEET_TASK_DETAILS,
    SET_AFE_ORDER_HEADER_DETAILS
} from "./AssetFleetProcessingType"

const initialState = {
    assetOrderHeaderDetail: [],
    assetFleetHeaderDetail: [],
    assetFleetItemDetail: [],
    assetFleetTaskDetail: [],
    assetAssignedToForAllItem: "",
    assetOpenAccordionList: []
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ASSET_OREDR_HEADER_DETAILS:
            return {
                ...state,
                assetOrderHeaderDetail: action.assetOrderHeaderDetail
            };
        case SET_AFE_ORDER_HEADER_DETAILS:
            return {
                ...state,
                afeOrderHeaderDetail: action.afeOrderHeaderDetail
            };
        case SET_ASSET_FLEET_HEADER_DETAILS:
            return {
                ...state,
                assetFleetHeaderDetail: action.assetFleetHeaderDetail
            };
        case SET_AFE_FLEET_HEADER_DETAILS:
            return {
                ...state,
                afeFleetHeaderDetail: action.afeFleetHeaderDetail
            };
        case SET_ASSET_FLEET_ITEM_DETAILS:
            return {
                ...state,
                assetFleetItemDetail: action.assetFleetItemDetail
            };
        case SET_AFE_FLEET_ITEM_DETAILS:
            return {
                ...state,
                afeFleetItemDetail: action.afeFleetItemDetail
            };
        case SET_ASSET_FLEET_TASK_DETAILS:
            return {
                ...state,
                assetFleetTaskDetail: action.assetFleetTaskDetail
            };
        case SET_AFE_FLEET_TASK_DETAILS:
            return {
                ...state,
                afeFleetTaskDetail: action.afeFleetTaskDetail
            };
        case SET_ASSET_ASSIGNED_TO_FOR_ALL_ITEM:
            return {
                ...state,
                assetAssignedToForAllItem: action.assetAssignedToForAllItem
            };
        case SET_ASSET_OPEN_ACCORDION_LIST:
            return {
                ...state,
                assetOpenAccordionList: action.list
            };
        default:
            return state;
    }
};

export default reducer;